import { Serializers } from "@megaron/serializers";

export const priceListsFiltersSerializer = Serializers.object({
  priceLists: Serializers.string.array(),
  items: Serializers.string.array(),
  searchText: Serializers.string,
  activeOn: Serializers.dateOnly,
}).partial();
